module.exports = __webpack_public_path__ + "Samsung_Galaxy_Tab_S3_icon.svg?a09efb11a75e08c8fe3fdd5cfacb1011";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Samsung_Galaxy_Tab_S3_icon.svg
// module id = 210
// module chunks = 0